import { styled } from '@mui/material/styles';
import React from 'react';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';

const PREFIX = 'SettingItem';

const classes = {
  icon: `${PREFIX}-icon`,
  listItemIcon: `${PREFIX}-listItemIcon`,
  listItem: `${PREFIX}-listItem`,
  listItemText: `${PREFIX}-listItemText`,
  secondaryText: `${PREFIX}-secondaryText`,
};

// @ts-expect-error: ListItem has problems
const StyledListItem: typeof ListItem = styled(ListItem)(({ theme }) => ({
  [`&.${classes.listItem}`]: {
    alignItems: 'flex-start',
  },

  [`& .${classes.icon}`]: {
    color: theme.palette.grey[600],
  },

  [`& .${classes.listItemIcon}`]: {
    marginTop: theme.spacing(1),
    minWidth: theme.spacing(5),
    paddingLeft: theme.spacing(1),
  },

  [`& .${classes.listItemText}`]: {
    marginTop: 0,
  },

  [`& .${classes.secondaryText}`]: {
    fontWeight: theme.typography.fontWeightMedium,
  },
}));

interface IProps {
  icon: React.ElementType<SvgIconProps>;
  primaryText: React.ReactNode;
  secondaryText: React.ReactNode;
}

const SettingItem = (props: IProps) => {
  return (
    <StyledListItem component={'div'} className={classes.listItem} disableGutters={true}>
      <ListItemIcon className={classes.listItemIcon}>
        {React.createElement(props.icon, { className: classes.icon })}
      </ListItemIcon>
      <ListItemText
        className={classes.listItemText}
        primary={props.primaryText}
        primaryTypographyProps={{ variant: 'caption', color: 'textSecondary' }}
        secondaryTypographyProps={{
          variant: 'body1',
          color: 'textPrimary',
          className: classes.secondaryText,
          component: 'div',
        }}
        secondary={props.secondaryText}
      />
    </StyledListItem>
  );
};

export default SettingItem;
